module.exports = __webpack_public_path__ + "static/img/logo1.24816f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/logo1.png
// module id = ZwR1
// module chunks = 22